export const WISHLIST_STRINGS = {
    LOGGED_OUT_MESSAGE: {
        FIRST_PART: "Looks like you're currently logged out and can't find your Wishlist.",
        SECOND_PART: "Log in or create a new account to find and browse your favorite bags."
    },
    EMPTY_WISHLIST_MESSAGE: "Your Wishlist is currently empty. Browse and save your favorite bags."
} as const; 